import React from 'react';

class RowItemKetQuaThanhTraDatDai extends React.Component {

  render() {
    let Item = this.props.item;
    let data = Item ? Item.soLieuBaoCaoInfo : {};
    return (
      <tr className={this.props.sum ? 'txt-bold' : ''}>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='column-name-fixed'>{data.tenDonVi}</td>

        <td className='txt-center'>{data.tongSoCuocThanhTra}</td>
        <td className='txt-center'>{data.kyTruocChuyenSang}</td>
        <td className='txt-center'>{data.trienKhaiTrongKyBaoCao}</td>
        <td className='txt-center'>{data.theoKeHoach}</td>
        <td className='txt-center'>{data.dotXuat}</td>
        <td className='txt-center'>{data.ketThucThanhTraTrucTiep}</td>
        <td className='txt-center'>{data.daBanHanhKetLuan}</td>
        <td className='txt-center'>{data.soDonViDuocThanhTra}</td>
        <td className='txt-center'>{data.soDonViCoViPham}</td>
        <td className='txt-center'>{data.tongViPhamTien}</td>
        <td className='txt-center'>{data.tongViPhamDat}</td>
        <td className='txt-center'>{data.datLanChiem}</td>
        <td className='txt-center'>{data.giaoDatCapDatSaiDoiTuong}</td>
        <td className='txt-center'>{data.capBanDatTraiThamQuyen}</td>
        <td className='txt-center'>{data.capGCNQSDDSai}</td>
        <td className='txt-center'>{data.chuyenNhuongChoThueKhongDungQuyDinh}</td>
        <td className='txt-center'>{data.suDungDatKhongDungMucDich}</td>
        <td className='txt-center'>{data.boHoangHoa}</td>
        <td className='txt-center'>{data.viPhamKhac}</td>
        <td className='txt-center'>{data.kienNghiThuHoiTien}</td>
        <td className='txt-center'>{data.kienNghiThuHoiDat}</td>
        <td className='txt-center'>{data.kienNghiThuHoiQDGiaoDat}</td>
        <td className='txt-center'>{data.kienNghiKhacTien}</td>
        <td className='txt-center'>{data.kienNghiKhacDat}</td>
        <td className='txt-center'>{data.hanhChinhToChuc}</td>
        <td className='txt-center'>{data.hanhChinhCaNhan}</td>
        <td className='txt-center'>{data.chuyenCoQuanDieuTraVu}</td>
        <td className='txt-center'>{data.chuyenCoQuanDieuTraDoiTuong}</td>
        <td className='txt-center'>{data.daThuTien}</td>
        <td className='txt-center'>{data.daThuDat}</td>
        <td className='txt-center'>{data.daThuQdGiaoDat}</td>
        <td className='txt-center'>{data.tongSoKLTTVaQDXLDaKTDD}</td>
        <td className='txt-center'>{data.ketQuaKiemTraDonDocTienPhaiThu}</td>
        <td className='txt-center'>{data.ketQuaKiemTraDonDocTienDaThu}</td>
        <td className='txt-center'>{data.ketQuaKiemTraDonDocDatPhaiThu}</td>
        <td className='txt-center'>{data.ketQuaKiemTraDonDocDatDaThu}</td>
        <td className='txt-center'>{data.daXuLyHanhChinhToChuc}</td>
        <td className='txt-center'>{data.daXuLyHanhChinhCaNhan}</td>
        <td className='txt-center'>{data.daKhoiToVu}</td>
        <td className='txt-center'>{data.daKhoiToDoiTuong}</td>
        <td className='ghi-chu'>{data.ghiChu}</td>
      </tr>
    );
  }
}

export default RowItemKetQuaThanhTraDatDai;


// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/datatable/RowItemKetQuaThanhTraDatDai.jsx